import { IList, IRecord } from 'annotation-tools/utils';
import {
  APIRawValidationErrorType,
  APIValidationErrorType,
  IAPIValidationErrorType
} from '../common/validation-error';
import { UserAPIRawSuccessResponseType } from '../user/api-response';
import {
  LoginAPIRawRequestBodyType,
  LoginAPIRequestBodyType
} from './api-request-body';

export type LoginAPIRawSuccessResponseType = {
  token: string;
  user: UserAPIRawSuccessResponseType;
};

export type LoginAPIRawValidationErrorType = APIRawValidationErrorType<
  LoginAPIRawRequestBodyType
>;

export type LoginAPIValidationErrorType = APIValidationErrorType<
  LoginAPIRequestBodyType
>;

export type ILoginAPIValidationErrorType = IAPIValidationErrorType<
  LoginAPIRequestBodyType
>;

export const ILoginAPIValidationErrorFactory = IRecord<
  LoginAPIValidationErrorType
>({
  email: IList<string>(),
  password: IList<string>()
});
